class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._openDelay = null;
    this._closeDelay = null;

    // Hover support – desktop only (≥990px)
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  onMouseEnter() {
    if (!this.isDesktop()) return;
    // Cancel any pending close from a previous mouseleave
    clearTimeout(this._closeDelay);
    // Open after a short delay so quick cursor pass-throughs are ignored
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this._openDelay = setTimeout(() => {
        const content = this.mainDetailsToggle.querySelector('.mega-menu__content');

        // Reset animation so it replays fresh on every hover (not just the first)
        if (content) {
          content.style.animationName = 'none';
          content.getBoundingClientRect(); // force reflow — paints element at opacity:0
        }

        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
        this.onToggle();

        // Restore animation in the next frame so CSS keyframe fires from scratch
        requestAnimationFrame(() => {
          if (content) content.style.animationName = '';
        });
      }, 180);
    }
  }

  onMouseLeave() {
    if (!this.isDesktop()) return;
    // Cancel a pending open if the cursor leaves before the delay fires
    clearTimeout(this._openDelay);
    // Small delay so accidental micro-exits don't snap the menu shut
    this._closeDelay = setTimeout(() => {
      this.close();
    }, 120);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  close() {
    // Clear any inline animation-name left over from the hover reset.
    // Without this, the inline style overrides CSS opacity:1 on the next click-open,
    // causing the menu to appear blank on smaller screens.
    const content = this.mainDetailsToggle.querySelector('.mega-menu__content');
    if (content) content.style.animationName = '';
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
